import { SaveOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Row, Select, Space, Table } from 'antd';
import Column from 'antd/es/table/Column';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { dateCommon } from '../../helpers/common';
import { DataSelectBox } from '../../models/selectbox';
import { chamCongNhat, getChamCongNhat, getLoaiChamCong } from '../../services/chamcong';
import viVN from 'antd/lib/date-picker/locale/vi_VN';

const TimeKeeping = () => {

    const [date, setDate] = useState<any>(dayjs());
    const [list, setList] = useState<Array<any>>([]);
    const [selectedItems, setSelectedItems] = useState<Array<any>>([]);
    const [optLoaiCong, setOptLoaiCong] = useState<Array<DataSelectBox>>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

    const getList = async () => {
        setIsLoading(true);
        var ngay = dateCommon.formatDate(date.$d, "dd/MM/yyyy");
        var data = await getChamCongNhat(ngay);
        var listData = (data || []).map((x: any, idx: number) => { return { ...x, key: idx } });
        setList(listData);
        setSelectedRowKeys((listData || []).filter((x: any) => !x.isDaChamCong && x.maLoaiCong != "W").map((x: any) => x.key));
        setSelectedItems((listData || []).filter((x: any) => !x.isDaChamCong && x.maLoaiCong != "W").map((x: any) => x));
        setIsLoading(false);
    }

    const getLoaiCong = async () => {
        var data = await getLoaiChamCong();
        setOptLoaiCong(data.map((x: any) => {
            return {
                "value": x.ma,
                "label": x.ma
            };
        }));
    }

    const eventChamCong = async () => {
        var d = (selectedItems || []).map(x => {
            return {
                idNhanVien: x.idNhanVien,
                maLoaiCong: x.maLoaiCong
            }
        });
        setIsLoading(true);

        try {
            var data = await chamCongNhat({
                date: date.$d,
                congNhanVien: d
            });
            setList(data);
            setSelectedRowKeys([]);
            toast.success("Chấm công thành công");
        } catch (e) {
            toast.error("Chấm công không thành công");
        }

        setIsLoading(false);
    }

    const onChangeTableSelection = (selectedRowKeys: React.Key[], selectedRows: any) => {
        setSelectedItems(selectedRows);
        setSelectedRowKeys(selectedRowKeys);
    }

    const getCheckboxProps = (record: any) => ({
        disabled: record.isDaChamCong,
        name: record.name
    })

    useEffect(() => {
        getList();
    }, [date]);

    useEffect(() => {
        getLoaiCong();
    }, []);

    const disabledDate = (current: any) => {
        return current && current > dayjs().endOf('day');
    };

    return (
        <>
            <Row style={{ marginBottom: "10px" }} align="middle">
                <Col xs={24} sm={12} md={12} style={{ display: 'flex', justifyContent: 'flex-start' }}>
                    <b style={{ fontSize: "20px", color: "#071C50" }}>Chấm công ngày</b>
                </Col>
                <Col xs={24} sm={12} md={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Row gutter={8} justify={{ xs: 'center'}}>
                        <Col>
                            <DatePicker
                                locale={viVN}
                                changeOnBlur={true}
                                className="custom-datepicker"
                                disabledDate={disabledDate}
                                disabled={isLoading}
                                size="small"
                                format={["DD/MM/YYYY", "DDMMYYYY"]}
                                value={date}
                                onChange={(e: any) => {
                                    if (e) {
                                        setDate(e);
                                    }
                                }}
                            />
                        </Col>
                        <Col>
                            <Button
                                style={{ width: "140px" } }
                                className="hrm-btn hrm-btn-warning"
                                icon={<SaveOutlined rev="" />}
                                onClick={eventChamCong}
                                loading={isLoading}
                            >
                                Chấm công
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        <Row>
            <div className="card" style={{ width: "100%"}}>
                <Table
                    scroll={{ y: 195, x: 800 }}
                    size="small"
                    loading={isLoading}
                    pagination={false}
                        dataSource={list.map((item: any, index: any) => {
                            return { ...item, key: index }
                        })}
                    rowSelection={{
                        type: "checkbox",
                        onChange: onChangeTableSelection,
                        selectedRowKeys: selectedRowKeys,
                        getCheckboxProps: getCheckboxProps
                    }}
                >
                    <Column title="Tên nhân viên" dataIndex="hoTen" key="hoTen" />
                    <Column title="Phòng ban" dataIndex="donVi" key="donVi" />
                    <Column title="Chức vụ" dataIndex="chucVu" key="chucVu" />
                        <Column width="65px" title="Công" render={(value, record: any) => {
                            if (record.isDaChamCong || record?.maLoaiCong == "W") {
                            return record.maLoaiCong;
                        } else {
                            return (
                                <Select
                                    options={optLoaiCong}
                                    value={record.maLoaiCong}
                                    onChange={(e) => {
                                        record.maLoaiCong = e;
                                        list.forEach(x => {
                                            if (x.idNhanVien === record.idNhanVien) {
                                                x.maLoaiCong = e;
                                            }
                                        });
                                        setList([...list]);
                                    }}>
                                </Select>)
                        }
                    }} />
                </Table>
            </div>
            </Row>
        </>
   );
};

export default TimeKeeping;
